import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import AppWithOnboarding from './AppWithOnboarding';
import Login from './Login';
import Startpagina from './Startpagina';
import Handhaving from './Handhaving';
import { uitloggen, openBeheeromgeving, zetSleutel, wieBenIk } from './api';

// Terug uit de beheeromgeving via de knop Hoofdmenu: de inlog staat dan achter
// het hekje in het adres (#sessie=...). Dat deel komt niet bij de server en
// wordt hier meteen uit het adres gehaald, zodat het niet in de geschiedenis of
// een gedeelde link blijft staan.
function sessieUitAdres() {
  if (typeof window === 'undefined') return null;
  const m = /(?:^#|&)sessie=([^&]+)/.exec(window.location.hash || '');
  if (!m) return null;
  try { window.history.replaceState(null, '', window.location.pathname + window.location.search); }
  catch (e) { window.location.hash = ''; }
  return decodeURIComponent(m[1]);
}
const MEEGEGEVEN_SESSIE = sessieUitAdres();

// Na het inloggen komt een beheerder eerst op de startpagina met de modules.
// Elke andere gebruiker gaat direct naar LaadAtlas, zoals voorheen.
function Root() {
  const [gebruiker, setGebruiker] = useState(null);
  const [module, setModule] = useState(null);
  const [herstellen, setHerstellen] = useState(!!MEEGEGEVEN_SESSIE);

  useEffect(() => {
    if (!MEEGEGEVEN_SESSIE) return;
    zetSleutel(MEEGEGEVEN_SESSIE);
    wieBenIk()
      .then(a => {
        const g = a && a.gebruiker;
        if (!g || g.moetWachtwoordWijzigen) throw new Error('Geen geldige inlog meegegeven.');
        zetSleutel(MEEGEGEVEN_SESSIE, g);
        setGebruiker(g);
      })
      .catch(e => {
        console.error('Inlog overnemen uit de beheeromgeving mislukt:', e.message);
        zetSleutel(null, null);
      })
      .finally(() => setHerstellen(false));
  }, []);

  if (herstellen) return null;

  if (!gebruiker) {
    return <Login onLogin={(naam, g) => { setGebruiker(g || { naam }); setModule(null); }} />;
  }

  const naam = gebruiker.naam || gebruiker.gebruikersnaam;
  const beheerder = gebruiker.rol === 'beheerder';

  if (beheerder && module === 'handhaving') {
    return <Handhaving onHoofdmenu={() => setModule(null)} />;
  }

  if (beheerder && module !== 'laadatlas') {
    return (
      <Startpagina
        onOpen={(id) => {
          if (id === 'laadatlas') setModule('laadatlas');
          else if (id === 'handhaving') setModule('handhaving');
          else if (id === 'cms') openBeheeromgeving();
        }}
        onUitloggen={async () => {
          try { await uitloggen(); }
          catch (e) { console.error('Uitloggen mislukt:', e.message); }
          setGebruiker(null);
          setModule(null);
        }}
      />
    );
  }

  return (
    <AppWithOnboarding
      currentUser={naam}
      onHoofdmenu={beheerder ? () => setModule(null) : null}
    />
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><Root /></React.StrictMode>);
